<template>
  <Result v-bind="err">
    <template #extra>
      <Button type="primary" @click="handleJumpRoute">
        {{ isLogin ? "返回首页" : "去登录" }}
      </Button>
    </template>
  </Result>
</template>

<script>
import { Result, Button } from 'ant-design-vue'
import { mapGetters } from 'vuex'
import { PAGE_NAME } from '@/utils/constant'
export default {
  name: 'Exception',
  components: {
    Result,
    Button
  },
  computed: {
    ...mapGetters(['isLogin']),
    err() {
      const { code = '404', msg = '访问的页面不存在~' } = this.$route.query
      const status = ['404', '403', '500'].includes(String(code))
        ? code
        : '500'
      return {
        title: code,
        subTitle: msg,
        status
      }
    }
  },
  methods: {
    handleJumpRoute() {
      if (this.isLogin) {
        this.$router.replace({
          name: PAGE_NAME.Home
        })
      } else {
        this.$router.replace({
          name: PAGE_NAME.Login
        })
      }
    }
  }
}
</script>
